export const sortStrings = (a, b) => a.localeCompare(b);
